module.exports = __webpack_public_path__ + "static/img/RAW2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAW2_1.png
// module id = mh0Z
// module chunks = 0